import React from 'react';
import { useCollection } from './CollectionContext';
import Button from '../common/Button';

/**
 * Adds one copy of the card to the collection, then turns into a stepper showing
 * how many copies are stored. The quantity comes from the collection context, so
 * it reflects the server rather than local click state.
 */
const AddToCollectionButton = props => {
  const { quantities, addCopy, setQuantity, removeCard } = useCollection();
  const quantity = quantities[props.card.id] || 0;

  if (!quantity) {
    return (
      <Button
        className="w-full"
        iconClass="fas fa-box"
        onClick={() => addCopy(props.card.id)}>
        Agregar a la colección
      </Button>
    );
  }

  return (
    <div className="flex flex-row items-center gap-x-1">
      <Button
        className="w-10 shrink-0"
        iconClass="fas fa-minus"
        onClick={() =>
          quantity > 1
            ? setQuantity(props.card.id, quantity - 1)
            : removeCard(props.card.id)
        }
      />
      <span className="flex-1 text-center text-white">
        {quantity} en colección
      </span>
      <Button
        className="w-10 shrink-0"
        iconClass="fas fa-plus"
        onClick={() => addCopy(props.card.id)}
      />
    </div>
  );
};

export default AddToCollectionButton;
